// extracted by mini-css-extract-plugin
export default {"noPasses":"Purchases_noPasses__zjubW","searchAndCSV":"Purchases_searchAndCSV__fVgyC","csv":"Purchases_csv__SR5a4"};